import styled from '@emotion/styled';
import TrashIcon from '@/assets/icons/trash.svg?react';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  padding: 4px 0 8px;
`;

export const RemoveIcon = styled(TrashIcon)`
  width: 20px;
  height: 20px;
  color: #fff;
`;

export const Backdrop = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0;
  cursor: pointer;
  border: none;
  background: rgb(0 0 0 / 50%);
  transition: opacity 0.2s ease;
  inset: 0;
`;

export const ThumbnailWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  overflow: hidden;
  border-radius: 4px;

  @media (${({ theme }) => theme.mediaMobile}) {
    & ${Backdrop} {
      opacity: 0.5;
    }
  }

  &:hover ${Backdrop} {
    opacity: 1;
  }
`;

export const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
